import { useSelector } from 'react-redux';

import ProviderInformation from 'pages/Profile/components/ProviderInformation';

export default function ProviderInformationDrawer() {
  const { location } = useSelector((state) => state.ui.drawer.data) || {};

  return (
    <div className="provider-information-drawer flex-column">
      <div className="w-100 flex-column">
        <h2 className="f28 mb-32">Information</h2>
        <ProviderInformation location={location} />
      </div>
    </div>
  );
}
